import React, { useState } from 'react'

import { useToolbarState, Toolbar, ToolbarItem } from 'reakit/Toolbar'
import styled from 'styled-components'

import ClientOrDoctor from './ClientOrDoctor'

import { Transition } from 'react-transition-group'
import animation from './animation.styled'
import { theme } from 'styled-tools'
import { navigate, Link } from 'gatsby'

const StyledToolbar = styled(Toolbar)`
	box-sizing: border-box;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	font-family: '-apple-system', 'system-ui, BlinkMacSystemFont', 'Segoe UI', 'Helvetica Neue', Helvetica, Arial,
		sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
	display: flex;
	flex-direction: row;
	&& {
		padding: 0 15px;
		background-color: ${theme('colors.white')};
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
		max-width: ${theme('container')};
		${animation};

		@media (max-width: 1024px) {
			padding: 1px 5px;
		}
	}
`

const LogoWrapper = styled.div`
	height: 61px;
	/* margin-right: 5%; */
	margin-right: 2%;

	padding: 0.5rem 0 0 0;

	@media (max-width: 1250px) {
		margin-right: 1%;
	}

	@media (max-width: 1100px) {
		margin-right: 1%;
	}
`

const SearchWrapper = styled.form`
	position: relative;
	display: flex;
	justify-content: flex-start;

	width: 100%;
	.icon {
		color: ${theme('colors.grayb8')};
		align-self: center;
		margin-left: -20px;
		z-index: 99999;
		height: 45px;
		/* position: absolute; */
	}
`

const WhiteBackground = styled.div`
	background-color: ${theme('colors.white')};
	width: 100%;
`

/**
 * Parte "branca" da barra em Desktop.
 * a prop 'show' é do RTG.
 * concentra a prop toolbar do Reakit.
 */
export default function Whitebar({ show, toggleType, type, logo, contatos, isClient }) {
	const toolbar = useToolbarState()
	const [inputSearch, setInputSearch] = useState('')

	const handleSearch = e => {
		e.preventDefault()
		if (inputSearch !== '') {
			navigate(`/busca?q=${inputSearch}`)
			setInputSearch('')
		}
	}

	const logoLinkTo = isClient ? '/' : '/medico/'

	return (
		<>
			<Transition in={show} unmountOnExit timeout={50}>
				{state => (
					<WhiteBackground>
						<StyledToolbar {...toolbar} aria-label='Primeira barra de navegação do site' state={state}>
							<ToolbarItem {...toolbar} as={Link} to={logoLinkTo}>
								<LogoWrapper id='logo-wrapper'>{logo}</LogoWrapper>
							</ToolbarItem>
							<ClientOrDoctor toolbar={toolbar} toggleType={toggleType} type={type} isClient={isClient} />
							<SearchWrapper id='form-search-global' onSubmit={handleSearch}></SearchWrapper>
						</StyledToolbar>
					</WhiteBackground>
				)}
			</Transition>
		</>
	)
}
